import React from 'react';
import { Bar } from 'react-chartjs-2';

const LegacyYearlySalesChart = ({ yearlySales, loading, selectedYear, onYearChange }) => {
    const barChartData = {
        labels: yearlySales && yearlySales.length > 0 
            ? yearlySales.map(item => item.month)
            : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Walk-in Orders',
                data: yearlySales && yearlySales.length > 0 
                    ? yearlySales.map(item => item.walkin_orders)
                    : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#F59E0B',
                borderColor: '#F59E0B',
                borderWidth: 1,
                stack: 'orders',
            },
            {
                label: 'LPO Orders',
                data: yearlySales && yearlySales.length > 0 
                    ? yearlySales.map(item => item.lpo_orders)
                    : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#3B82F6',
                borderColor: '#3B82F6',
                borderWidth: 1,
                stack: 'orders',
            },
            {
                label: 'Walk-in Delivered',
                data: yearlySales && yearlySales.length > 0 
                    ? yearlySales.map(item => item.walkin_delivered_orders)
                    : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#10B981',
                borderColor: '#10B981',
                borderWidth: 1,
                stack: 'delivered',
            },
            {
                label: 'LPO Delivered',
                data: yearlySales && yearlySales.length > 0 
                    ? yearlySales.map(item => item.lpo_delivered_orders)
                    : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#776acf',
                borderColor: '#776acf',
                borderWidth: 1,
                stack: 'delivered',
            }
        ],
    };

    const barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        plugins: {
            legend: {
                position: 'top',
                onClick: null,
            },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        return context.dataset.label + ': ' + context.parsed.y + ' orders';
                    }
                }
            }
        },
        scales: {
            x: {
                display: true,
                title: {
                    display: false,
                    text: 'Months'
                },
                grid: {
                    display: false,
                },
                stacked: true,
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: {
                    display: false,
                    text: 'Total Orders'
                },
                grid: {
                    display: false,
                },
                beginAtZero: true,
                stacked: true,
            },
        },
    };

    return (
        <div className="chart-card h-100">
            <div className="chart-header d-flex justify-content-between align-items-center">
                <h3 className="title mb-0">Yearly Sales</h3>
                <select 
                    className="year-selector form-select" 
                    style={{ width: 'auto' }}
                    value={selectedYear}
                    onChange={(e) => onYearChange(parseInt(e.target.value))}
                >
                    {Array.from({ length: 15 }, (_, idx) => {
                        const year = new Date().getFullYear() - idx;
                        return (
                            <option key={year} value={year}>{year}</option>
                        );
                    })}
                </select>
            </div>
            <div className="chart-container my-4" style={{ height: '300px' }}>
                {loading ? (
                    <div className="placeholder-chart d-flex align-items-center justify-content-center h-100 rounded"
                        style={{ background: 'rgba(0, 102, 255, 0.1)' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="chart-wrapper h-100">
                        <Bar 
                            data={barChartData} 
                            options={barChartOptions}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default LegacyYearlySalesChart;
